import type { TournamentPrizeFragment } from '../../../../graphql/TournamentFragment.generated';

type Props = {
  prizes?: TournamentPrizeFragment[];
  position?: number;
};

const getPrizeForPosition = ({ prizes, position }: Props) =>
  prizes?.find((prize) => prize.forPosition === position);

export default getPrizeForPosition;
